import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import initializeQuickActionsOptionViewState from '../../actions/quickActions/initializeQuickActionsOptionViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

// We are not using a mutatorAction since it does not log any datapoint - https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki?pagePath=%2FClient%2FArchitecture%2FAnalytics&wikiVersion=GBwikiMaster
// not a public interface and hence function doc not needed here

const initializeQuickActionsOptionViewStateMutator = mutator(
    initializeQuickActionsOptionViewState,
    actionMessage => {
        const store = getOptionsStore();
        if (store) {
            const configuration = getUserConfiguration().ViewStateConfiguration;
            store.activeViewState = {
                name: ActiveItem.QuickActions,
                isDirty: false,
                isLoading: false,
                rightSwipeAction: configuration.MailRightSwipeAction,
                leftSwipeAction: configuration.MailLeftSwipeAction,
            } as ActiveOptionViewState;
        }
    }
);

// exported only for testing purposes
export default initializeQuickActionsOptionViewStateMutator;
